import { render, staticRenderFns } from "./PromotionIndex.vue?vue&type=template&id=a61d098a"
import script from "./PromotionIndex.vue?vue&type=script&lang=js"
export * from "./PromotionIndex.vue?vue&type=script&lang=js"
import style0 from "./PromotionIndex.vue?vue&type=style&index=0&id=a61d098a&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports